import { ExternalLink } from "lucide-react";

/**
 * Ecosystem banner — thin strip shown at top of the app (both logged-in and public).
 * Visually different from the app palette (papaya orange) — uses gold/purple to
 * signal "different level" (ecosistema ZapHQ.space).
 */
export default function EcosystemBanner() {
  return (
    <a
      href="https://www.zaphq.space/zaphq"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="ecosystem-banner"
      className="group relative z-40 flex items-center justify-center gap-2 border-b border-[#F5B942]/30 bg-gradient-to-r from-[#1a1030] via-[#2a1a4a] to-[#1a1030] px-4 py-1.5 text-[11px] font-semibold tracking-wide text-[#F5B942] transition hover:brightness-125"
    >
      <span className="text-[#C084FC]" aria-hidden="true">◉</span>
      <span>
        una <span className="font-bold text-white">Casa</span> di{" "}
        <span className="font-bold underline-offset-2 group-hover:underline">ZapHQ.space</span>
      </span>
      <ExternalLink className="h-3 w-3 opacity-60 transition group-hover:opacity-100" />
    </a>
  );
}
